// this is for pdfs and other binary files.  we want to keep assets.thi just for images
export default function (folder: string, filename: string) {
  const { isProduction } = useUtils()
  const mode = isProduction() ? 'production' : 'staging'

  if (!folder || !filename) return undefined
  return `https://static.thiecommerce.com/assets/${mode}/${folder}/${filename}`
}
